import Modal from "./_bootstrapModalExtensions";
import NotificationUtil from "./_notificationUtil";
import * as BootstrapAlertMessage from "./_bootstrapAlertMessage";
import * as Url from "./Utils/UrlUtil";
import Interfaces from "./_interfaces";
import Classes from "./_classes";

export function UserRoleModification(event: JQuery.TriggeredEvent): void {
    let $switch: JQuery<HTMLElement> = $(event.currentTarget);
    let isDeletion: boolean = getIsDeletionStatus();
    let userGuid: string = $switch.attr('data-userguid');
    let userName: string = $switch.attr('data-username');
    let question: string;
    let submitFunc: Function = () => {
        let officeId: number = $('#selectedOfficeId').val() as number;

        if (!officeId) {
            return;
        }

        ToggleOfficeAdminRole(event, isDeletion, userGuid, userName, false, officeId);
    };
    let rejectFunc: Function = () => {
        $('#selectedOfficeId').val('');
        $('#selectedOfficeDisplayName').val('');

        $switch.prop('checked', isDeletion);
    };

    if ($(event.target).hasClass('user-role-switch')) {
        let role: string = $(event.target).attr('data-role');
        question = isDeletion
            ? `Biztosan elveszed ${userName} felhasználótól a(z) ${role} jogosultságot?`
            : `Biztosan megadod ${userName} felhasználónak a(z) ${role} jogosultságot?`;

        Modal.showConfirmationWindowAsync(
            question,
            'Megerősítés',
            () => ToggleUserRole(event, isDeletion, userGuid, role, userName),
            () => { $switch.prop('checked', isDeletion); },
            'Igen',
            'Nem')
    }

    if ($(event.target).hasClass('office-admin-role-switch')) {
        let isOfficeAlreadyChosen: boolean = $(event.target).attr('data-is-office-chosen') === 'True';
        question = isDeletion
            ? `Biztosan elveszed ${userName} felhasználó hatósági rendszeradminisztrátori jogosultságát?`
            : `Biztosan adsz ${userName} felhasználónak hatósági adminisztrátori jogosultságot?`;

        // Request confirmation
        Modal.showConfirmationWindowAsync(
            question,
            'Megerősítés',
            () => {
                if (isDeletion) {
                    // Adding delay to let the previous modal close
                    setTimeout(() => {
                        // Question about hard remove
                        Modal.showConfirmationWindowAsync(
                            'Törölve legyen egyúttal a felhasználó összes hatósági jogosultsága, szerepköre is, hogy biztosan megszűnjön a hatósági regisztrációja?',
                            'Felhasználó összes hatósági jogosultságának törlése',
                            () => ToggleOfficeAdminRole(event, isDeletion, userGuid, userName, true, 0),
                            () => ToggleOfficeAdminRole(event, isDeletion, userGuid, userName, false, 0),
                            'Igen',
                            'Nem');
                    }, 1000);
                } else {
                    isOfficeAlreadyChosen
                        ? ToggleOfficeAdminRole(event, isDeletion, userGuid, userName, false, 0)
                        : Modal.ShowBootstrapModalWithCustomContent(
                            'Válassz hatóságot',
                            window.ETDR_RD.appConfig['UrlAction.ListAllOfficesPartial'],
                            null,
                            submitFunc,
                            rejectFunc);
                }
            },
            () => { $switch.prop('checked', isDeletion); },
            'Igen',
            'Nem')
    }

    function getIsDeletionStatus(): boolean {
        if ($switch.is('input')) {
            return !$switch.is(':checked');
        } else {
            return $switch.hasClass('grid_delete');
        }
    }
}

export function ToggleUserRole(event: JQuery.TriggeredEvent, isDeletion: boolean, userGuid: string, role: string, userName: string): void {
    $.ajax({
        method: 'POST',
        url: window.ETDR_RD.appConfig['UrlAction.AddOrRemoveUserRole'],
        data: {
            'isDeletion': isDeletion,
            'userGuid': userGuid,
            'role': role,
        },
        async: false,
        success: function (data) {
            if (!data.success) {
                BootstrapAlertMessage.ShowBootstrapAlertMessageOnPage('#messageDiv', BootstrapAlertMessage.BootstrapAlertType.danger, data.message, 'userlist-message');
            } else {
                if (isDeletion) {
                    // Change the icon
                    $(event.target).removeClass('grid_delete').addClass('grid_tools');
                } else {
                    // Change the icon
                    $(event.target).removeClass('grid_tools').addClass('grid_delete');
                }

                let messageText: string = isDeletion
                    ? `${userName} felhasználótól a(z) ${role} jogosultság elvétele sikeres volt.`
                    : `${userName} felhasználónak a(z) ${role} jogosultság megadása sikeres volt.`;

                // Show the message about the succesful request
                BootstrapAlertMessage.ShowBootstrapAlertMessageOnPage('#messageDiv', BootstrapAlertMessage.BootstrapAlertType.success, messageText, 'userlist-message', true);
            }
        },
        error: () => {
            // If the frontend server threw an exception (e.g. 404, internal server error, etc)
            BootstrapAlertMessage.ShowBootstrapAlertMessageOnPage('#messageDiv', BootstrapAlertMessage.BootstrapAlertType.danger, 'Hiba az Ajax kérés elküldésekor. Töltse újra az oldalt!', 'userlist-message');
        }
    });
}

export function ToggleOfficeAdminRole(event: JQuery.TriggeredEvent, isDeletion: boolean, userGuid: string, userName: string, isHardRemoveFromOffice: boolean, officeId: number): void {
    $.ajax({
        method: 'POST',
        url: window.ETDR_RD.appConfig['UrlAction.AddOrRemoveOfficeAdminRole'],
        data: {
            'isDeletion': isDeletion,
            'userGuid': userGuid,
            'officeId': officeId,
            'isHardRemoveFromOffice': isHardRemoveFromOffice
        },
        async: false,
        success: function (data) {
            let $switch = $(event.target);

            if (!data.success) {
                BootstrapAlertMessage.ShowBootstrapAlertMessageOnPage('#messageDiv', BootstrapAlertMessage.BootstrapAlertType.danger, data.message, 'userlist-message');

                if (!isDeletion) {
                    $switch.prop('checked', false);
                }

                Modal.closeGenericModal();
            } else {
                if (isDeletion) {
                    // Change the toggle icon
                    $switch.removeClass('grid_delete').addClass('grid_tools');

                    if (data.userLeftTheOffice) {
                        if ($switch.is('input')) {
                            // Untick the checkbox
                            $switch.parent().parent().siblings().closest('.registered-to-office-cell').children().children().prop('checked', false);

                            // Delete Office DisplayName field
                            $switch.parent().parent().siblings().closest('.office-displayname-cell').text('');
                        } else {
                            // Untick the checkbox
                            $switch.parent().siblings().closest('.registered-to-office-cell').children().children().prop('checked', false);

                            // Delete Office DisplayName field
                            $switch.parent().siblings().closest('.office-displayname-cell').text('');
                        }

                        // Change the data attribute for is-office-chosen
                        $switch.attr('data-is-office-chosen', 'False');
                    }
                } else {
                    let selectedOfficeDisplayName: string = $('#selectedOfficeDisplayName').val() as string;

                    // Change the toggle icon
                    $switch.removeClass('grid_tools').addClass('grid_delete');

                    // Tick the checkbox
                    if ($switch.is('input')) {
                        $switch.parent().parent().siblings().closest('.registered-to-office-cell').children().children().prop('checked', true);
                    } else {
                        $switch.parent().siblings().closest('.registered-to-office-cell').children().children().prop('checked', true);
                    }

                    // Change the data attributes
                    $switch.attr('data-is-office-chosen', 'True');

                    // Fill out the Office DisplayName field if it isn't filled already
                    let $officeDisplayNameinCellSelector: JQuery;

                    if ($switch.is('input')) {
                        $officeDisplayNameinCellSelector = $switch.parent().parent().siblings().closest('.office-displayname-cell');
                    } else {
                        $officeDisplayNameinCellSelector = $switch.parent().siblings().closest('.office-displayname-cell');
                    }

                    if ($officeDisplayNameinCellSelector.text().trim() === '') {
                        $officeDisplayNameinCellSelector.text(selectedOfficeDisplayName);
                    }

                    // Delete the value
                    $('#selectedOfficeDisplayName').val('');
                }

                let messageText: string = isDeletion
                    ? `${userName} felhasználótól a "Hatósági rendszeradminisztrátor" jogosultság elvétele sikeres volt.`
                    : `${userName} felhasználónak a "Hatósági rendszeradminisztrátor" jogosultság megadása sikeres volt.`

                // Show the message about the succesful request
                BootstrapAlertMessage.ShowBootstrapAlertMessageOnPage('#messageDiv', BootstrapAlertMessage.BootstrapAlertType.success, messageText, 'userlist-message', true);

                Modal.closeGenericModal();
            }
        },
        error: () => {
            // Client <-> Server communication error. The frontend server threw an exception (e.g. 404, internal server error, etc)
            BootstrapAlertMessage.ShowBootstrapAlertMessageOnPage('#messageDiv', BootstrapAlertMessage.BootstrapAlertType.danger, 'Hiba az Ajax kérés elküldésekor. Töltse újra az oldalt!', 'userlist-message',);
        }
    });
}

export function OnGridFocusedRowChangedInOfficeList(s: ASPxClientGridView, e: ASPxClientGridViewSelectionEventArgs) {
    s.GetRowValues(s.GetFocusedRowIndex(), 'Id;DisplayName', OnGetRowValuesInOfficeList);
}

export function OnGetRowValuesInOfficeList(values: string[]) {
    $("#selectedOfficeId").val(values[0]);
    $("#selectedOfficeDisplayName").val(values[1]);
}

function OnParameterElementClicked(event: JQuery.TriggeredEvent, editTemplateUrl: string, saveTemplateUrl: string, gridName: string) {
    event.preventDefault();
    event.stopPropagation();

    let type: number = $(event.currentTarget).data('type-id');
    let urlTemplate: string = window.ETDR_RD.appConfig[editTemplateUrl];
    let editUrl: string = Url.createUrlFromTemplate(urlTemplate, { type: type });
    let saveUrl: string = window.ETDR_RD.appConfig[saveTemplateUrl];
    let titleText: string = $('#data-div').data('modal-title');
    let modalTitle: string;

    if (titleText) {
        modalTitle = titleText;
    } else {
        modalTitle = 'Időkorlát beállítása';
    }

    createModalFormForListElement(modalTitle, gridName, editUrl, saveUrl);
}

function AddOrEditPreliminaryRequestType(event: JQuery.TriggeredEvent) {
    let $button: JQuery = $(event.currentTarget);
    let id: number = $button.data('type-id');

    if (id === undefined) {
        id = 0;
    }

    let modalTitle: string;
    let editUrlTemplate: string = window.ETDR_RD.appConfig['UrlTemplate.EditPreliminaryRequestType'];
    let editUrl: string = Url.createUrlFromTemplate(editUrlTemplate, { id: id });
    let saveUrl: string = window.ETDR_RD.appConfig['UrlAction.SavePreliminaryRequestType'];;

    if (id) {
        modalTitle = 'Előzetes megkeresés adatainak szerkesztése';
    } else {
        modalTitle = 'Új előzetes megkeresés felvétele';
    }

    createModalFormForListElement(modalTitle, 'PreliminaryRequestTypeList', editUrl, saveUrl);
}

function createModalFormForListElement(modalTitle: string, gridName: string, editUrl: string, saveUrl: string) {


    Modal.showBootstrapModalWithAjaxContent(GetModalSettings());

    function GetModalSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        settings.title = modalTitle;
        settings.contentUrl = editUrl;
        settings.saveUrl = saveUrl;
        settings.callback = RefreshGridAndDisplaySuccess(gridName);
        settings.enableUnobtrusiveValidation = null;
        settings.infoText = null;

        return settings;
    }
}

function DeletePreliminaryRequestType(event: JQuery.TriggeredEvent) {
    const $btn: JQuery = $(event.currentTarget);
    const requestTypeName: string = $btn.data('request-type-name');
    const preliminaryRequestTypeId: number = $btn.data('type-id');

    let acceptCallback = (): void => {
        $.ajax({
            method: 'POST',
            url: window.ETDR_RD.appConfig['UrlTemplate.DeletePreliminaryRequestType'],
            data: {
                id: preliminaryRequestTypeId
            },
            headers: { Accept: 'application/json' }
        })
            .done((data: Interfaces.BaseJsonResponse) => {
                if (data.success) {
                    const grid: MVCxClientGridView = window['PreliminaryRequestTypeList'] as MVCxClientGridView;
                    NotificationUtil.Success('Sikeres törlés');
                    grid.Refresh();
                } else {
                    NotificationUtil.Error(data.errorText);
                }
            })
            .fail((jqXHR: JQueryXHR) => {
                // Client <-> Server communication error. The frontend server threw an exception (e.g. 404, internal server error, etc)
                NotificationUtil.Error('Hiba történt a szerverrel elérése közben. Lejárt a session vagy nem elérhető a frontend.');
            });
    };

    Modal.showConfirmationWindowAsync(`Biztosan törlöd a(z) "<b>${requestTypeName}</b>" megnevezésű elemet?`, 'Előzetes megkeresés típus törlése', acceptCallback, () => { }, 'Igen', 'Nem');
}

function AddZipCodeRelation() {
    const templateUrl: string = window.ETDR_RD.appConfig['UrlAction.NewZipCodeRelationTemplate'];
    const saveUrl: string = window.ETDR_RD.appConfig['UrlTemplate.AddZipCodeRelation'];

    Modal.showBootstrapModalWithAjaxContent(GetModalSettings());

    function GetModalSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        settings.title = 'Új irányítószám-település reláció felvétele';
        settings.contentUrl = templateUrl;
        settings.saveUrl = saveUrl;
        settings.callback = RefreshGridAndDisplaySuccess('ZipCodeAndSettlementRelationListPartial');
        settings.enableUnobtrusiveValidation = null;
        settings.infoText = null;

        return settings;
    }
}

function RefreshGridAndDisplaySuccess(gridName: string) {
    return () => {
        let grid: MVCxClientGridView = window[gridName] as MVCxClientGridView;
        grid.Refresh();

        NotificationUtil.Success('Sikeres módosítás');
    }
};

function DeleteZipCodeRelation(event: JQuery.TriggeredEvent) {
    let $btn: JQuery = $(event.currentTarget);
    let zipCodeId: number = $btn.data('zipcode-id');
    let zipCode: string = $btn.data('zipcode');
    let settlementId: number = $btn.data('settlement-id');
    let settlementName: string = $btn.data('settlement-name');

    let acceptCallback = (): void => {
        $.ajax({
            method: 'POST',
            url: window.ETDR_RD.appConfig['UrlTemplate.DeleteZipCodeRelation'],
            data: {
                zipCodeId: zipCodeId,
                settlementId: settlementId
            },
            headers: { Accept: 'application/json' }
        })
            .done((data: Interfaces.BaseJsonResponse) => {
                if (data.success) {
                    let grid: MVCxClientGridView = window['ZipCodeAndSettlementRelationListPartial'] as MVCxClientGridView;

                    NotificationUtil.Info('Sikeres törlés');
                    grid.Refresh();
                } else {
                    NotificationUtil.Error(data.errorText);
                }
            })
            .fail((jqXHR: JQueryXHR) => {
                // Client <-> Server communication error. The frontend server threw an exception (e.g. 404, internal server error, etc)
                NotificationUtil.Error('Hiba történt a szerverrel elérése közben. Lejárt a session vagy nem elérhető a frontend.');
            });
    };

    Modal.showConfirmationWindowAsync(
        `Biztosan törlöd a(z) "<b>${zipCode} - ${settlementName}</b>" összerendelést?`,
        'Irányítószám-település reláció törlése',
        acceptCallback, () => { },
        'Igen',
        'Nem');
}

export function TestTakarnetConnection(event: JQuery.TriggeredEvent) {
    event.preventDefault();

    Modal.showBootstrapModalWithAjaxContent(getSettings());

    function getSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let modalSettings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        modalSettings.title = 'Takarnet interfész kapcsolat tesztelése';
        modalSettings.contentUrl = window.ETDR_RD.appConfig['UrlAction.GetTestTakarnetConnectionView'];
        modalSettings.saveUrl = window.ETDR_RD.appConfig['UrlAction.TestTakarnetConnection'];
        modalSettings.callback = (data: Interfaces.BaseJsonResponse) => { callback(data); };
        modalSettings.enableUnobtrusiveValidation = false;
        modalSettings.closeModalWindowAfterSave = false;
        modalSettings.saveText = 'Teszt indítása';
        modalSettings.showRejectButton = false;

        return modalSettings;

        function callback(data: Interfaces.BaseJsonResponse) {
            let text: string = data.success ? data.message : data.errorText;

            $('#takarnet-connection-test-response').text(text);
        }
    }
}

export function InitUserSearchForMainAdmin() {
    $('.form-control').on('keypress', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();

            PerformUserSearch();
        }
    });

    $('#user-search-button').on('click', () => {
        PerformUserSearch();
    });

    $('#user-search-reset').on('click', () => {
        userSearchReset();
    });
}

export function PerformUserSearch() {
    const grid: MVCxClientGridView = window['UserSearchForMainAdmin'];
    const model: Interfaces.UserSearchForMainAdminSearchParams = getSearchParamsModel();

    grid.PerformCallback(model);
}

export function OnUserListForMainAdminBeginCallback(s: ASPxClientRichEdit, e: MVCxClientBeginCallbackEventArgs) {
    e.customArgs['searchParams'] = getSearchParamsModel();
}

function getSearchParamsModel(): Interfaces.UserSearchForMainAdminSearchParams {
    return {
        userId: $('#user-id').val() as number,
        idmId: $('#user-idmid').val() as number,
        userDisplayName: $('#user-display-name').val() as string,
        uniqueId: $('#user-unique-id').val() as string,
        email: $('#user-email').val() as string,
        officeDisplayName: $('#office-display-name').val() as string,
        isRegisteredToOffice: $('#is-registered-to-office').is(':checked'),
        isSystemAdmin: $('#is-system-admin').is(':checked'),
        isOfficeAdmin: $('#is-office-admin').is(':checked'),
        isSystemCustomerService: $('#is-system-customer-service').is(':checked'),
        isIntegratedCustomerService: $('#is-integrated-customer-service').is(':checked'),
        isSystemInspector: $('#is-system-inspector').is(':checked')
    };
}

export function userSearchReset() {
    $('form').trigger('reset');
}

jQuery(() => {
    $(document).on('click', '.userlist-switch', (event: JQuery.TriggeredEvent) => { UserRoleModification(event); });

    $(document).on('click', '.edit-pa-dates', (event: JQuery.TriggeredEvent) => {
        OnParameterElementClicked(event, 'UrlTemplate.EditProcessActionParameters', 'UrlAction.SaveProcessActionParameters', 'ProcessActionParameterList');
    });

    $(document).on('click', '.edit-decision-dates', (event: JQuery.TriggeredEvent) => {
        OnParameterElementClicked(event, 'UrlTemplate.EditDecisionParameters', 'UrlAction.SaveDecisionParameters', 'DecisionParameterList');
    });

    $(document).on('click', '.edit-order-dates', (event: JQuery.TriggeredEvent) => {
        OnParameterElementClicked(event, 'UrlTemplate.EditOrderParameters', 'UrlAction.SaveOrderParameters', 'OrderParameterList');
    });

    $(document).on('click', '.edit-petition-dates', (event: JQuery.TriggeredEvent) => {
        OnParameterElementClicked(event, 'UrlTemplate.EditPetitionParameters', 'UrlAction.SavePetitionParameters', 'PetitionParameterList');
    });

    $(document).on('click', '#add-preliminary-request-type-btn', (event: JQuery.TriggeredEvent) => {
        AddOrEditPreliminaryRequestType(event);
    });

    $(document).on('click', '.delete-preliminary-request', (event: JQuery.TriggeredEvent) => {
        DeletePreliminaryRequestType(event);
    });

    $(document).on('click', '.edit-preliminary-request', (event: JQuery.TriggeredEvent) => {
        AddOrEditPreliminaryRequestType(event);
    });

    $(document).on('click', '#new-zipcode-settlement-relation', () => {
        AddZipCodeRelation();
    });

    $(document).on('click', '.delete-zipcode-relation', (event: JQuery.TriggeredEvent) => {
        DeleteZipCodeRelation(event);
    });

    $(document).on('click', '#takarnet-connection-test', (event: JQuery.TriggeredEvent) => {
        TestTakarnetConnection(event);
    });
});
